import { render, staticRenderFns } from "./ViewTelecom.vue?vue&type=template&id=07f0b356&scoped=true"
import script from "./ViewTelecom.vue?vue&type=script&lang=js"
export * from "./ViewTelecom.vue?vue&type=script&lang=js"
import style0 from "./ViewTelecom.vue?vue&type=style&index=0&id=07f0b356&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f0b356",
  null
  
)

export default component.exports